module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step2-pict02-4462347dcd7f4ec83080bc0f88da6922.jpg";